import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../../config';

const API_URL = config.API_URL;

export const fetchFinancialSummary = createAsyncThunk(
  'summary/fetchFinancialSummary',
  async ({ userId, year } = {}) => {
    const token = localStorage.getItem('token');
    const params = new URLSearchParams({ userId });
    if (year) params.append('year', year);
    const response = await axios.get(
      `${API_URL}/api/projects/project-summary?${params.toString()}`,
      {
        headers: { 'x-auth-token': token }
      }
    );
    return response.data;
  }
);

const summarySlice = createSlice({
  name: 'summary',
  initialState: {
    overall: {
      totalIncome: 0,
      totalExpenses: 0,
      totalBalance: 0
    },
    projects: [],
    status: 'idle',
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFinancialSummary.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchFinancialSummary.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.overall = action.payload.overall;
        state.projects = action.payload.projects;
      })
      .addCase(fetchFinancialSummary.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

export default summarySlice.reducer;